export function useDrawers() {
  return useState('drawers', () => ({
    cart: {
      open: false,
      // True while an add-to-cart mutation is in flight — the drawer opens
      // optimistically and shows a skeleton line until the order lands.
      adding: false,
    },
    navigation: {
      open: false,
    },
  }))
}
